import axios from '@/axios'
import { Notify, Loading, QSpinnerTail } from 'quasar'

export default {
  state: {
    freights: [],
    pages: ''
  },
  actions: {
    calculateDistance ({ dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.get(`/distance/between/${json.collectCity.city}/${json.deliveryCity.city}`)
        .then(res => {
          try {
            json.distance = Math.round(res.data.rows[0].elements[0].distance.value / 1000)
            dispatch('postFreight', json)
          } catch (err) {
            console.log(err)
            dispatch('postFreight', json)
          }
        })
        .catch(err => {
          console.log(err)
          dispatch('postFreight', json)
        })
    },
    postFreight ({ dispatch }, json) {
      axios.post('/platform/freight', json)
        .then(res => {
          Notify.create({
            message: 'Frete cadastrado com sucesso! Cadastre mais fretes ou visualize os mesmos no seu perfil.',
            position: 'top',
            type: 'positive'
          })
          Loading.hide()
        })
        .catch(err => {
          if (err.response.data.status === 'NOT_FOUND') {
            Notify.create({
              message: 'Sua companhia não existe ou não está ativada. Cadestre seu frete como pessoa física ou aguarde sua companhia ser validada!',
              position: 'top',
              type: 'negative'
            })
          }
          Loading.hide()
        })
    },
    deleteFreight ({ dispatch }, json) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.delete(`/platform/freight/${json.id}`)
        .then(res => {
          Notify.create({
            message: 'Frete removido com sucesso!',
            position: 'top',
            type: 'positive'
          })
          dispatch('getFreight', json.currentPage)
          Loading.hide()
        })
        .catch(err => {
          console.log(err)
          Loading.hide()
        })
    },
    getFreight ({ commit }, index) {
      Loading.show({ spinner: QSpinnerTail, spinnerSize: 80, spinnerColor: 'blue' })
      axios.get(`/platform/freight?limit=6&page=${index - 1}`)
        .then(res => {
          commit('setFreights', res.data)
          Loading.hide()
        })
        .catch(err => {
          Loading.hide()
          console.log(err)
        })
    }
  },
  mutations: {
    setFreights (state, data) {
      state.freights = []
      state.freights = data.content
      state.pages = data.totalPages
    }
  },
  getters: {
    getFreights: state => {
      return state.freights
    },
    getPagesFreight: (state) => {
      return state.pages
    }
  }
}
